export default class Bambus {
    constructor() {
        this.number = 4;
        this.label = 'Bambusramme';
        this.image_name = 'bambus';
        this.id = 'frame-' + this.image_name;
        this.path = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/';
        this.extension = '.png';
        this.src = this.path + this.image_name + this.extension;
        this.paperOuterPadding = 8;
        this.addFrameShadow = false;
        this.frameCount = 1;
    }
}
